<script setup lang="ts">
import { computed } from 'vue';

import { useCardsStore } from '../../store/cards.store';
import CardTransactionDrawer from './CardTransactionDrawer.vue';

const { transactionId } = defineProps<{ transactionId: string | null }>();

const visible = defineModel<boolean>('visible', { required: true });

const cardsStore = useCardsStore();

const transaction = computed(() =>
  transactionId === null ? null : cardsStore.getTransaction(transactionId),
);
const card = computed(() =>
  transaction.value === null ? null : cardsStore.getCard(transaction.value.cardId),
);
</script>

<template>
  <CardTransactionDrawer
    v-if="card && transaction"
    v-model:visible="visible"
    :card="card"
    :transaction="transaction"
  />
</template>
